// src/auth/PrivateRoute.js
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DataContext } from "../context/DataContext";

export default function PrivateRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const { data } = useContext(DataContext);
  const location = useLocation();

  // 1) While auth is initializing, show nothing (or a spinner)
  if (loading) return null;

  // 2) If not logged in, send to login
  if (!user) {
    return (
      <Navigate
        to="/auth/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // 3) If allowedRoles is provided, enforce the role check
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const userProfile = data.userProfile || {};

    // Build effectiveRoles = [ userProfile.role, "superuser" if is_superuser ]
    const effectiveRoles = [];
    if (userProfile.role) effectiveRoles.push(userProfile.role);
    if (userProfile.is_superuser) effectiveRoles.push("superuser");

    // If none of allowedRoles intersects effectiveRoles, block
    const isAllowed = allowedRoles.some((role) =>
      effectiveRoles.includes(role)
    );

    if (!isAllowed) {
      // Redirect to a safe page (e.g. “/admin/customer”)
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  // 4) Otherwise, pass through
  return children;
}
